import React, { useState, Fragment } from 'react';
import CookieService from './CookieService';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { Image, Link } from '../commonComponents';
import { appsflyer_icon, download_icon } from '../../assets/imgs';
import { appsflyerLink} from 'Root/constants';
import './Appsflyer.scss';

const COOKIE_NAME = 'cookie_appsflyer_agreed';

const notEmptyUrl = window.location.pathname === '#/';
const Appsflyer = () => {
  const [cookieAccepted, setCookieAccepted] = useState(false);

  const onAccept = () => {
    CookieService.setCookie(COOKIE_NAME, '1');
    setCookieAccepted(true);
  };

  const notLoginPage =
    window.location.href.indexOf('login') === -1 ? true : false;
  const cookieNotAgreed = !CookieService.getCookie(COOKIE_NAME);
  // comment the chinaUrl check to make it work in local mode else it will only work in china.
  const showCookie =
    !cookieAccepted &&
    notLoginPage &&
    cookieNotAgreed &&
    !notEmptyUrl;

  return (
    <React.Fragment>
      {showCookie ? (
        <div className='appsflyer show'>
          <div className="appsflyer-inner">
            <span className="appsflyer--close" onClick={onAccept}></span>
            <div>
              <Image src={appsflyer_icon} className="appsflyer-icon-logo" />
              <span className="appsflyer--text">
                <FormattedHTMLMessage id="appsflyer.appsflyer_message" defaultMessage="Download the app and get more benefits" />
              </span>
              <Link className="appsflyer--button" href={appsflyerLink} target="_blank">
                <Fragment>
                  <FormattedMessage id="appsflyer.appsflyer_download" defaultMessage="Download" />
                  <Image src={download_icon} className="appsflyer-icon-download" />
                </Fragment>
              </Link>
            </div>
          </div>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default Appsflyer;
